  <!--
 * @Descripttion:数据库连接配置管理页面
 * @version: 0.0.1
 * @Author: haihua.xu
 * @Date: 2020-03-16 9:17:20
 * @LastEditors: haihua.xu
 * @LastEditTime: 2020-03-16 18:37:56
 -->
<!--  -->
<template>
  <basicContainer style="padding-left: 10px;">
    <div class="easyCruds_head">
      <i class="fa fa-table easyCruds_head_icon" style="color:#409EFF"></i>
      <span class="easyCruds_head_title" style="color:#409EFF">&nbsp;数据库连接配置</span>
    </div>
    <div class="el-card__body">
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page="page"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="refresh"
        @cell-click="cellClick"
      >
        <!-- 操作按钮扩展 -->
        <template slot="menuLeft">
          <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDelete">删 除</el-button>
        </template>
        <!-- 状态栏目扩展  -->
        <template v-slot:status="{row,label,dic,$index}">
          <el-tag v-if="label === '启用'" type="success">{{label}}</el-tag>
          <el-tag v-else type="info">{{label}}</el-tag>
        </template>
        <!-- 自定义表单测试按钮 -->
        <template slot-scope="scope" slot="menuForm">
          <el-button
            type="primary"
            style="margin-left: -90%;"
            icon="el-icon-check"
            size="small"
            plain
            @click="testConnection()"
          >测试连接性</el-button>
        </template>
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>
export default {
  name: 'RuleGroupManage',
  data() {
    return {
      form: {

      },
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      // 是否连接成功
      connenctionFlag: false,
      selectionList: [],
      option: {
        title: '检测数据库配置',
        dialogWidth: 1000,
        dialogHeight: 400,
        menuPosition: 'center',
        height: 500,
        align: 'center',
        tip: false,
        columnBtn: false,
        // searchMenuSpan: 8,
        stripe: false,
        border: true,
        index: false,
        viewBtn: false,
        delBtn: false,
        selection: true,
        // title:'系统连接列表',
        column: [
          {
            label: '连接名称',
            prop: 'conName',
            overHidden: true,

            labelWidth: 100,
            // searchLabelWidth: 120,
            // searchSpan: 8,
            span: 12,
            search: true,
            rules: [{
              required: true,
              message: '请输入连接名称',
              trigger: 'blur'
            }]
          },

          {
            label: '数据库类型',
            prop: 'dbType',
            overHidden: true,
            labelWidth: 100,
            span: 12,
            type: 'select',
            dicData: [],
            change: (obj) => {
              // 获取数据驱动的选择列表数据
              this.getDatabaseDriverList(obj.value)
            },
            rules: [{
              required: true,
              message: '请选择数据库类型',
              trigger: 'blur'
            }]
          },
          {
            label: '驱动',
            labelWidth: 100,
            prop: 'driver',
            type: 'select',
            span: 24,
            dicData: [],
            change: (obj) => {
              // 获取数据驱动地址的选择列表数据
              this.getDatabaseUrlList(obj.value)
            },
            props: {
              label: 'label',
              value: 'label'
            },
            overHidden: true,
            rules: [{
              required: true,
              message: '数据库驱动必填',
              trigger: 'blur'
            }]
          },
          {
            label: '连接地址',
            labelWidth: 100,
            prop: 'url',
            span: 24,
            search: true,
            overHidden: true,
            rules: [{
              required: true,
              message: '连接地址必填',
              trigger: 'blur'
            }]
          },
          {
            label: '用户名',
            labelWidth: 100,
            prop: 'userName',

            overHidden: true,
            span: 12,
            rules: [{
              required: true,
              message: '请输入用户名',
              trigger: 'blur'
            }]
          },
          {
            label: '密码',
            labelWidth: 100,
            prop: 'userPwd',
            type: 'password',

            span: 12,
            hide: true,
            rules: [{
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            }]
          },
          {
            label: '模式名',
            labelWidth: 100,
            prop: 'schemaName',

            span: 12,
            overHidden: true,
            rules: [{
              required: true,
              message: '请输入模式名称',
              trigger: 'blur'
            }]
          },
          {
            label: '连接数',
            labelWidth: 100,
            prop: 'conCount',
            type: 'number',
            span: 12,
            overHidden: true,
            rules: [{
              required: true,
              message: '请输入连接数',
              trigger: 'blur'
            }]
          },
          {
            label: '超时时间',
            labelWidth: 100,
            prop: 'conOut',
            type: 'number',
            span: 12,
            overHidden: true,
            rules: [{
              required: true,
              message: '请输入连接超时时间',
              trigger: 'blur'
            }]
          },
          {
            label: '状态',
            prop: 'status',
            labelWidth: 100,
            type: 'select',
            slot: true,
            search: false,
            span: 12,
            dicData: [
              {
                label: '启用',
                value: 1
              },
              {
                label: '停用',
                value: 2
              }
            ],
            overHidden: true,
            rules: [{
              required: true,
              message: '请选择状态',
              trigger: 'blur'
            }]
          },
          {
            label: '测试sql',
            labelWidth: 100,
            prop: 'testSql',
            overHidden: true,

            type: 'textarea',
            hide: true,
            span: 24,
            rows: 3,
            rules: [{
              required: true,
              message: '请输入测试sql',
              trigger: 'blur'
            }]
          }
        ]
      },
      data: []

    }
  },

  components: {},

  mounted() {
    this.getDatabaseList()
  },
  methods: {
    cellClick: function(row, column, cell, event) {
      this.$refs.crud.toggleRowSelection(row)
    },
    refresh: function() {
      this.onLoad()
    },

    searchReset() {
      this.query = {}
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.query = params
      this.onLoad()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    // 测试连接性
    testConnection() {
      // 封装请求参数
      var connectionData = {
        userName: this.form.userName,
        userPwd: this.form.userPwd,
        url: this.form.url,
        driver: this.form.driver
      }
      // 先校验表单
      this.$refs.crud.validate((valid) => {
        if (!valid) {
          // 校验不通过
          return false
        } else {
          // 校验通过
          this.$http.post(`/con-system/validatedConnection`, JSON.stringify(connectionData),
          ).then(response => {
            this.$message.success('测试数据库连接成功')
            this.connenctionFlag = true
          }).catch(error => {
            this.$message.error(error.msg)
          })
          this.connenctionFlag = false
          return true
        }
      })
    },
    rowSave(row, loading, done) {
      if (this.connenctionFlag === true) {
        // 提交表单
        this.$http.post('/con-system', JSON.stringify(row),
        ).then(response => {
          this.$message.success('添加数据库连接表成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
      } else {
        alert('请先测试连接,成功后方可保存数据')
      }
    },
    rowUpdate(row, index, loading, done) {
      this.$http.put('/con-system', JSON.stringify(row), { headers: { 'content-type': 'application/json' }}
      ).then(response => {
        this.$message.success('编辑成功') && loading()
        this.onLoad()
      }).catch(error => {
        this.$message.error(error.msg) && done()
      })
    },
    rowDel(row, index) {
      this.deleteRows([row], () => {
        this.data.splice(index, 1)
      })
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        return this.$message.warning('请选择至少一条数据')
      }
      this.deleteRows(this.selectionList, () => {
        this.onLoad()
      })
    },
    deleteRows: function(deleteList, callback) {
      this.$confirm('确定删除所选记录?是：删除；否：返回列表', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$http.delete('/con-system', { params: { idList: deleteList.map(item => item.id) }}).then(
          response => {
            this.$message.success('删除成功') && typeof callback === 'function' && callback()
          }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(e => { })
    },
    // 获取数据库类型列表
    getDatabaseList() {
      this.$http.get(`/pub/dm-const/listByCataCode?cataCode=db_type`,
      ).then(
        response => {
          this.option.column[1].dicData = response.data
        }
      ).catch(
        error => {
          this.$message.error(error.msg)
        }
      )
    },
    // 获取数据库连接地址列表
    getDatabaseUrlList(itemCode) {
      if (itemCode && itemCode && itemCode !== null && itemCode !== '') {
        this.$http.get(`/pub/dm-const/listByCataCodeItemCode?cataCode=db_url&itemCode=${itemCode}`,
        ).then(
          response => {
            if (!this.form.url) {
              if (response.data.length > 0) {
                this.form.url = response.data[0].label
              } else {
                this.form.url = this.form.url
              }
            } else {
              this.form.url = this.form.url
            }
          }
        ).catch(
          error => {
            this.$message.error(error.msg)
          }
        )
      }
    },
    // 获取数据库驱动类列表
    getDatabaseDriverList(itemCode) {
      if (itemCode && itemCode && itemCode !== null && itemCode !== '') {
        this.$http.get(`/pub/dm-const/listByCataCodeItemCode?cataCode=db_driver&itemCode=${itemCode}`,
        ).then(
          response => {
            this.option.column[2].dicData = response.data
          }
        ).catch(
          error => {
            this.$message.error(error.msg)
          }
        )
      }
    },

    onLoad(page = this.page, params = this.query) {
      this.loading = true
      params.pageNum = page.currentPage,
      params.pageSize = page.pageSize
      this.$http.get('/con-system/query', { params: params }
      ).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    }
  }
}
</script>
<style lang='scss' scoped>
</style>

